<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <dicesList v-if="isDicesList" :isShow="isDicesList" :dicesData="dicesData" @changePop="changePop"></dicesList>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import UPDATE from '@/components/page/update'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import dicesList from '../activity/components/dicesDetailTable'
import Url from '@/views/crs/util/url'

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE,
    dicesList
  },
  methods: {
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }
    },
    bthClick(clickName, row) {
      if (clickName == 'getDetail') {
        this.isDicesList = true
        this.dicesData = row;
      }
    },
    changePop(val) {
      this.isDicesList = val
    }
  },
  data() {
    return {
      queryData: {},
      detailsVisible: false,
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: '賬號', field: 'customerNumber', isNumber: true },
          { title: '活動ID', field: 'actId', isNumber: true },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.activity.dicesBalance,
        selection: false,
        sequence: true,
        method: 'get',
        cols: [
          {
            title: '時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '賬號', field: 'customerNumber' },
          { title: '活動ID', field: 'actId' },
          { title: '關卡', field: 'level' },
          { title: '塞子數', field: 'quantity' },
          {
            title: window.$t('crs.bt.operation'),
            btnClick: [
              {
                name: '明細詳情',
                click: 'getDetail',
                type: 'primary'
              }
            ]
          }
        ]
      },
      isDicesList: false,
      dicesData: {}
    }
  }
}
</script>
